var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tasks-template',{attrs:{"tool":_vm.module}})
}
var staticRenderFns = []

export { render, staticRenderFns }